"use client";

import Script from "next/script";

type GoogleTagManagerProps = {
  gtmId: string;
  dataLayerName?: string;
  dataLayer?: Record<string, unknown>;
  gtmScriptUrl?: string;
  nonce?: string;
};

export default function GoogleTagManager({
  gtmId,
  dataLayerName = "dataLayer",
  dataLayer,
  gtmScriptUrl = "https://www.googletagmanager.com/gtm.js",
  nonce,
}: GoogleTagManagerProps) {
  if (!gtmId) {
    return null;
  }

  const gtmLayer = dataLayerName !== "dataLayer" ? `&l=${dataLayerName}` : "";

  return (
    <>
      <Script
        id="gtm-init"
        nonce={nonce}
        dangerouslySetInnerHTML={{
          __html: `
          (function(w,l){
            w[l]=w[l]||[];
            w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
            ${dataLayer ? `w[l].push(${JSON.stringify(dataLayer)})` : ""}
          })(window,'${dataLayerName}');
        `,
        }}
        strategy="afterInteractive"
      />
      <Script
        id="gtm-script"
        nonce={nonce}
        src={`${gtmScriptUrl}?id=${gtmId}${gtmLayer}`}
        strategy="afterInteractive"
      />
    </>
  );
}
